import { UserRoleTypes } from "./user-role-types";
import { UntypedFormGroup } from "@angular/forms";

import { User } from "./user";
import { UserCompanyInfo } from "./user-company-info";
import { UserRole } from "./user-role";
import { UserPermission } from "./user-permission";
import { CompanyInfo } from "../companies/company-info";

interface IRegisterUserHandler {
  handlerFormToUser(formGroup: UntypedFormGroup): User;
}

export class RegisterUserHandler implements IRegisterUserHandler {
  public handlerFormToUser(userForm: UntypedFormGroup): User {
    const userCompanyInfo = new UserCompanyInfo();
    userCompanyInfo.setTelephone(userForm.get("telephone").value);
    userCompanyInfo.setFiscalNumber(userForm.get("fiscalNumber").value.replace(/[./-]/g, ""));
    userCompanyInfo.setHealthProfessional(userForm.get("isHealthProfessional").value);

    if (userCompanyInfo.isHealthProfessional()) {
      userCompanyInfo.setClassCouncil(userForm.get("classCouncil").value);
      userCompanyInfo.setRegistrationNumber(userForm.get("registrationNumber").value);
    } else {
      userCompanyInfo.setClassCouncil(null);
      userCompanyInfo.setRegistrationNumber(null);
    }

    const userRole: UserRole = userForm.get("userRole").value;

    if (userRole.isAdministratorRole()) {
      userRole.setUserPermissionList([]);
    } else {
      userRole.setUserPermissionList(userForm.get("userPermissionList").value);
    }

    const user = new User();
    user.setUserKey(userForm.get("userKey").value);
    user.setActivate(userForm.get("active").value);
    user.setName(userForm.get("name").value);
    user.setEmail(userForm.get("email").value);
    user.setAllowedCompanies(userForm.get("allowedCompanies").value);
    user.setUserCompanyInfo(userCompanyInfo);
    user.setUserRoleList([userRole]);
    user.correlatedId = userForm.get("externalClientId").value;

    return user;
  }

  public handlerUserToForm(userKey: string, user: User, userRoleList: UserRole[], userForm: UntypedFormGroup): void {
    let userRole: UserRole;
    let userPermissionList: UserPermission[] = [];
    let telephoneType: number = null;
    let password: string = null;

    if (user.getUserCompanyInfo() && user.getUserCompanyInfo().isMobile()) {
      telephoneType = 1;
    } else {
      telephoneType = 0;
    }

    if (user.getUserRoleList().length > 0) {
      userRole = userRoleList.find((userRole) => userRole.getUserRoleKey() === user.getUserRoleList()[0].getUserRoleKey());

      userPermissionList = userRole.getUserPermissionList().filter((i) => {
        let exist = false;

        for (const e of user.getUserRoleList()[0].getUserPermissionList()) {
          if (exist) break;
          else exist = e.getCode() === i.getCode();
        }

        return exist;
      });
    }

    userForm.setValue({
      userKey: userKey,
      name: user.getName(),
      email: user.getEmail(),
      password: password,
      telephoneType: telephoneType,
      telephone: user.getUserCompanyInfo().getTelephone()
        ? user
            .getUserCompanyInfo()
            .getTelephone()
            .replace(/[^\d]+/g, "")
        : "",
      externalClientId: user.correlatedId || "",
      fiscalNumber: user.getUserCompanyInfo().getFiscalNumber() ? user.getUserCompanyInfo().getFiscalNumber().replace(/[./-]/g, "") : "",
      isHealthProfessional: user.getUserCompanyInfo().isHealthProfessional() ? user.getUserCompanyInfo().isHealthProfessional() : false,
      classCouncil: user.getUserCompanyInfo().getClassCouncil() ? user.getUserCompanyInfo().getClassCouncil() : "",
      registrationNumber: user.getUserCompanyInfo().getRegistrationNumber() ? user.getUserCompanyInfo().getRegistrationNumber() : "",
      userRole: userRole,
      userPermissionList: userPermissionList,
      allowedCompanies: user.getUserCompanyInfo() ? user.getUserCompanyInfo() : [],
      active: user.isActivate(),
      changePassword: false,
      newPassword: "",
      confirmNewPassword: "",
      filterText: "",
      companyType: 2,
      city: "",
      region: "",
    });
  }
}
